if (!customElements.get('product-stories')) {
  class ProductStories extends HTMLElement {
    constructor() {
      super();
      this.currentSlide = 0;
      this.timer = null;
      this.progressBars = [];
      this.activeStory = null;
    }

    connectedCallback() {
      this.storyItems = this.querySelectorAll(".story-item");
      this.modal = this.querySelector(".stories-modal");
      this.storyContents = this.querySelectorAll(".stories-modal-content");
      this.prevBtn = this.querySelectorAll(".story-nav.story-prev");
      this.nextBtn = this.querySelectorAll(".story-nav.story-next");
      this.progressContainer = this.querySelector(".story-progress");
      this.storyCircles = this.querySelectorAll(".story-circle");
      this.playButtons = this.querySelectorAll(".play-button");
      this.pauseButtons = this.querySelectorAll(".pause-button");
      this.muteButtons = this.querySelectorAll(".mute-button");
      this.unmuteButtons = this.querySelectorAll(".unmute-button");
      this.closeBtns = this.querySelectorAll(".story-slide-close");
      this.prevStoryBtn = this.querySelectorAll(".story-nav.change-story-prev");
      this.nextStoryBtn = this.querySelectorAll(".story-nav.change-story-next");
      this.storyContentsWrap = this.querySelector(".stories-modal-wrapper");

      this.addEventListeners();
    }

    hideHeaderAndCart() {
      this.headers = Array.from(document.querySelectorAll('.shopify-section-group-header-group'));
      this.stickyCart = document.querySelector('.product__sticky-cart');
      this.headersPrevDisplay = this.headers.map(header => header.style.display);

      this.headers.forEach(header => {
        header.style.display = 'none';
      });
      if (this.stickyCart) {
        this.stickyCartPrevDisplay = this.stickyCart.style.display;
        this.stickyCart.style.display = 'none';
      }
    }

    restoreHeaderAndCart() {
      if (this.headers && this.headersPrevDisplay) {
        this.headers.forEach((header, i) => {
          header.style.display = this.headersPrevDisplay[i] ?? '';
        });
      }
      if (this.stickyCart) this.stickyCart.style.display = this.stickyCartPrevDisplay ?? '';
    }

    showSlide(index, story, progressBarStatus = true) {
      // Exit if no active story
      if (!this.activeStory) return;

      const actveStory = story || this.activeStory;
      // Get slides and progress bars for current story content
      const slides = actveStory.querySelectorAll(".story-slide");
      const progressBars = actveStory.querySelectorAll(
        ".story-progress-bar-fill"
      );

      const activeSlide = slides[this.currentSlide];
      const video = activeSlide?.querySelector("video");
      if (video) {
        video.pause();
        video.currentTime = 0;
      }

      const videos = this.querySelectorAll("video:not(.story-circle video)");
      videos.forEach((video) => {
        video.pause();
        video.currentTime = 0;
      });

      if (progressBars[this.currentSlide] && progressBarStatus) {
        progressBars[this.currentSlide].style.transition = "";
        progressBars[this.currentSlide].style.width = "100%";
      }

      slides.forEach((slide) => slide.classList.remove("active"));

      // Show the current slide
      this.currentSlide = (index + slides.length) % slides.length;
      slides[this.currentSlide].classList.add("active");

      // Reset all progress bars
      if (progressBarStatus) {
        progressBars.forEach((bar, i) => {
          bar.style.transition = "";
          bar.style.width = i < this.currentSlide ? "100%" : "0%";
        });
      }
      // Play video if it's a video slide
      const mediaElement =
        slides[this.currentSlide].querySelector(".story-media");
      if (mediaElement?.tagName === "VIDEO") {
        mediaElement.currentTime = 0;
        if(progressBarStatus){
          // Check if video is ready to play (lazy loaded)
          const tryPlay = () => {
            if (mediaElement.readyState >= 2 || !mediaElement.classList.contains('lazy-video')) {
              mediaElement.play().catch(e => console.log('Video play failed:', e));
              mediaElement.muted = false;
            } else {
              // Wait for lazy loading to complete
              setTimeout(tryPlay, 50);
            }
          };
          tryPlay();
        }
        const playButton =
          slides[this.currentSlide].querySelector(".play-button");
        if (playButton) playButton.style.display = "none";
        const pauseButton =
          slides[this.currentSlide].querySelector(".pause-button");
        if (pauseButton) pauseButton.style.display = "flex";
        const muteButton =
          slides[this.currentSlide].querySelector(".mute-button");
        if (muteButton) muteButton.style.display = "flex";
        const unmuteButton =
          slides[this.currentSlide].querySelector(".unmute-button");
        if (unmuteButton) unmuteButton.style.display = "none";
      }

      // Start timer for auto-advance
      clearTimeout(this.timer);
      if (progressBarStatus) {
        this.startProgress();
      }
    }

    startProgress() {
      if (!this.activeStory) return;

      const slides = this.activeStory.querySelectorAll(".story-slide");
      const progressBars = this.activeStory.querySelectorAll(
        ".story-progress-bar-fill"
      );

      const duration =
        parseInt(slides[this.currentSlide].dataset.duration) || 5000;
      const mediaElement =
        slides[this.currentSlide].querySelector(".story-media");

      if (mediaElement?.tagName === "VIDEO") {
        // Remove existing event listener if any
        if (mediaElement._nextSlideHandler) {
          mediaElement.removeEventListener(
            "ended",
            mediaElement._nextSlideHandler
          );
        }
        mediaElement._nextSlideHandler = () => this.nextSlide();
        mediaElement.addEventListener("ended", mediaElement._nextSlideHandler);
      } else {
        this.timer = setTimeout(() => this.nextSlide(), duration);
      }

      // Animate progress bar
      const progressBar = progressBars[this.currentSlide];
      if (progressBar) {
        progressBar.style.transition = ``;
        progressBar.style.width = "0";

        progressBar.offsetWidth;

        progressBar.style.transition = `width ${duration}ms linear`;
        progressBar.style.width = "100%";
      }
    }

    prevSlide() {
      if (this.currentSlide > 0) {
        this.showSlide(this.currentSlide - 1);
      } else {
        this.closeModal();
      }
    }

    nextSlide() {
      if (!this.activeStory) return;

      const slides = this.activeStory.querySelectorAll(".story-slide");

      if (this.currentSlide < slides.length - 1) {
        this.showSlide(this.currentSlide + 1);
      } else {
        this.closeModal();
      }
    }

    openModal(storyId) {
      // Hide all story contents first and remove active/prev/next classes
      this.storyContents.forEach((content) => {
        content.style.display = "none";
        content.classList.remove("active", "prev", "next");
      });

      // Find the story content by ID or index
      let storyContent;
      if (typeof storyId === "string") {
        storyContent = this.querySelector(`.stories-modal-content#${storyId}`);
      } else if (typeof storyId === "number") {
        storyContent = this.storyContents[storyId];
      }

      if (!storyContent) return;

      // Set the active story and make it visible
      this.activeStory = storyContent;
      this.activeStory.style.display = "block";
      this.activeStory.classList.add("active"); // Add active class

      // Update navigation buttons with story indices
      const storyIndex = parseInt(this.activeStory.dataset.storyIndex || 0);
      this.prevStoryBtn.forEach((btn) => {
        btn.dataset.index = storyIndex;
      });
      this.nextStoryBtn.forEach((btn) => {
        btn.dataset.index = storyIndex;
      });

      // Add prev and next classes
      const prevIndex = storyIndex - 1;
      const nextIndex = storyIndex + 1;

      if (prevIndex >= 0) {
        this.storyContents[prevIndex].classList.add("prev");
      }
      if (nextIndex < this.storyContents.length) {
        this.storyContents[nextIndex].classList.add("next");
      }

      // Show modal and initialize to first slide
      this.modal.style.display = "block";
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";

      this.hideHeaderAndCart();
      this.currentSlide = 0;
      this.showSlide(0);

      // Add clicked class to the corresponding story circle
      const thumbIndex = parseInt(this.activeStory.dataset.storyIndex || 0);
      if (this.storyCircles[thumbIndex]) {
        this.storyCircles[thumbIndex].classList.add("clicked");
      }
    }

    closeModal() {
      this.modal.style.display = "none";
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "auto";
      clearTimeout(this.timer);

      this.restoreHeaderAndCart();
      this.storyCircles.forEach((circle) => {
        circle.classList.remove("clicked");
      });

      // Remove active class from all story contents
      this.storyContents.forEach((content) => {
        content.classList.remove("active", "prev", "next");
      });

      // Pause any playing videos
      const videos = this.modal.querySelectorAll("video");
      videos.forEach((video) => video.pause());

      this.activeStory = null;
    }

    openModalStory(direction) {
      if (!this.activeStory) return;

      const currentIndex = parseInt(this.activeStory.dataset.storyIndex || 0);
      const totalStories = this.storyContents.length;
      let newIndex = direction === "next" ? currentIndex + 1 : currentIndex - 1;

      if (newIndex < 0) newIndex = totalStories - 1;
      if (newIndex >= totalStories) newIndex = 0;

      // Remove all prev/next/active classes
      this.storyContents.forEach((content) => {
        content.classList.remove("active", "prev", "next");
      });

      const newStoryContent = this.storyContents[newIndex];
      if (newStoryContent) {
        newStoryContent.style.display = "block";
        this.activeStory.style.display = "none";

        newStoryContent.classList.add("active"); // Add active class to new story

        // Add prev and next classes
        const prevIndex = newIndex - 1;
        const nextIndex = newIndex + 1;

        if (prevIndex >= 0) {
          this.storyContents[prevIndex].classList.add("prev");
        }
        if (nextIndex < this.storyContents.length) {
          this.storyContents[nextIndex].classList.add("next");
        }

        this.activeStory = newStoryContent;
        this.activeStory.dataset.storyIndex = newIndex;
        this.currentSlide = 0;
        this.showSlide(0);

        // Update navigation buttons with new story index
        this.prevStoryBtn.forEach((btn) => {
          btn.dataset.index = newIndex;
        });
        this.nextStoryBtn.forEach((btn) => {
          btn.dataset.index = newIndex;
        });

        // Add clicked class to the corresponding story circle
        this.storyCircles.forEach((circle) => circle.classList.remove("clicked"));
        if (this.storyCircles[newIndex]) {
          this.storyCircles[newIndex].classList.add("clicked");
        }
      }
    }

    setupTouchNavigation() {
      let touchStartX = 0;
      let touchEndX = 0;
      let rotationY = 0;
      let hasMoved = false; // Flag to track if touchmove occurred

      this.modal.addEventListener(
        "touchstart",
        (e) => {
          touchStartX = e.changedTouches[0].screenX;
          hasMoved = false;
        },
        { passive: true }
      );

      this.modal.addEventListener(
        "touchmove",
        (e) => {
          hasMoved = true;
          const nextStory = this.querySelector(".stories-modal-content.next");
          const prevStory = this.querySelector(".stories-modal-content.prev");

          if (nextStory) {
            nextStory.style.display = "block";
            this.showSlide(0, nextStory, false);
          }
          if (prevStory) {
            prevStory.style.display = "block";
            this.showSlide(0, prevStory, false);
          }

          const currentX = e.changedTouches[0].screenX;
          let deltaX = currentX - touchStartX;

          const screenRatio = deltaX / window.innerWidth;
          const maxDeg = 45;

          const normalizedDelta = Math.min(0.5, Math.max(-0.5, screenRatio));
          rotationY = maxDeg * normalizedDelta * 2;

          // Apply transforms
          if (this.activeStory) {
            this.storyContentsWrap.style.transform = `translateZ(-50vw) rotateY(${rotationY}deg)`;
          }
        },
        { passive: true }
      );

      this.modal.addEventListener(
        "touchend",
        async (e) => {
          touchEndX = e.changedTouches[0].screenX;
          const swipeDelta = touchEndX - touchStartX;
          const swipeThreshold = window.innerWidth * 0.2;

          const nextStory = this.querySelector(".stories-modal-content.next");
          const prevStory = this.querySelector(".stories-modal-content.prev");
          let nextStoryDeg = 0;
          let prevStoryDeg = 0;
          if (nextStory) {
            nextStoryDeg = -90;
          }
          if (prevStory) {
            prevStoryDeg = 90;
          }

          if (this.activeStory && hasMoved) {
            if (Math.abs(swipeDelta) >= swipeThreshold) {
              this.storyContentsWrap.style.transition = "transform 0.3s ease-out";
              this.storyContentsWrap.style.transform = `translateZ(-50vw) rotateY(${rotationY < 0 ? nextStoryDeg : prevStoryDeg
                }deg)`;
              if (rotationY < 0 && nextStory) {
                await new Promise((resolve) => setTimeout(resolve, 300));
                this.storyContentsWrap.style.transition = "transform 0s ease-out";
                this.storyContentsWrap.style.transform = `translateZ(-50vw) rotateY(0deg)`;
                this.activeStory
                  .querySelector(".story-nav.change-story-next")
                  .click();
              } else if (rotationY > 0 && prevStory) {
                await new Promise((resolve) => setTimeout(resolve, 300));
                this.storyContentsWrap.style.transition = "transform 0s ease-out";
                this.storyContentsWrap.style.transform = `translateZ(-50vw) rotateY(0deg)`;
                this.activeStory
                  .querySelector(".story-nav.change-story-prev")
                  .click();
              }
            } else {
              this.storyContentsWrap.style.transition = "transform 0.3s ease-out";
              this.storyContentsWrap.style.transform = `translateZ(-50vw) rotateY(0deg)`;
              this.showSlide(this.currentSlide, this.activeStory);
            }
          }
        },
        { passive: true }
      );
    }

    handleSwipe(startX, endX, minDistance) {
      const swipeDistance = endX - startX;

      // If we're already at the start/end of stories and swiping in that direction, do nothing
      const currentIndex = parseInt(this.activeStory.dataset.storyIndex || 0);
      const isFirstStory = currentIndex === 0;
      const isLastStory = currentIndex === this.storyContents.length - 1;

      // Check if swipe is significant enough
      if (Math.abs(swipeDistance) >= minDistance) {
        if (swipeDistance > 0) {
          // Swiped right - go to previous
          if (!isFirstStory) {
            this.openModalStory("prev");
          }
        } else {
          // Swiped left - go to next
          if (!isLastStory) {
            this.openModalStory("next");
          }
        }
      }
    }

    addEventListeners() {
      this.storyItems.forEach((item) => {
        item.addEventListener("click", () => {
          const storyId = item.dataset.storyId;
          this.openModal(storyId);
        });
      });

      this.prevBtn.forEach((btn) => {
        btn.addEventListener("click", () => this.prevSlide());
      });

      this.nextBtn.forEach((btn) => {
        btn.addEventListener("click", () => this.nextSlide());
      });

      this.closeBtns.forEach((btn) => {
        btn.addEventListener("click", () => this.closeModal());
      });

      this.playButtons.forEach((button) => {
        button.addEventListener("click", () => {
          const slide = button.closest(".story-slide");
          const slideIndex = Array.from(
            this.activeStory.querySelectorAll(".story-slide")
          ).indexOf(slide);
          const progressBar = this.activeStory.querySelectorAll(
            ".story-progress-bar-fill"
          )[slideIndex];
          const video = slide.querySelector("video");

          if (video) {
            // Check if video is ready to play (lazy loaded)
            const tryPlay = () => {
              if (video.readyState >= 2 || !video.classList.contains('lazy-video')) {
                video.play().catch(e => console.log('Video play failed:', e));

                if (progressBar) {
                  progressBar.style.width = "100%";
                  progressBar.style.transition = `width ${video.duration * 1000 || 5000
                    }ms linear`;
                }
              } else {
                // Wait for lazy loading to complete
                setTimeout(tryPlay, 50);
              }
            };
            tryPlay();
          }

          button.style.display = "none";
          const pauseButton = slide.querySelector(".pause-button");
          if (pauseButton) {
            pauseButton.style.display = "flex";
          }
        });
      });

      this.pauseButtons.forEach((button) => {
        button.addEventListener("click", () => {
          const slide = button.closest(".story-slide");
          const slideIndex = Array.from(
            this.activeStory.querySelectorAll(".story-slide")
          ).indexOf(slide);
          const progressBar = this.activeStory.querySelectorAll(
            ".story-progress-bar-fill"
          )[slideIndex];
          const video = slide.querySelector("video");

          if (video) {
            video.pause();
          }

          // Calculating the current width of the progress bar in percentage
          if (progressBar) {
            const computedStyle = window.getComputedStyle(progressBar);
            const currentWidthPx = computedStyle.width;
            const currentWidthValue = parseFloat(currentWidthPx);
            const parentWidth = progressBar.parentElement.offsetWidth;
            const widthPercentage = (currentWidthValue / parentWidth) * 100;

            progressBar.style.width = `${widthPercentage}%`;
            progressBar.style.transition = "";
          }

          button.style.display = "none";
          const playButton = slide.querySelector(".play-button");
          if (playButton) {
            playButton.style.display = "flex";
          }
        });
      });

      this.muteButtons.forEach((button) => {
        button.addEventListener("click", () => {
          const video = button.closest(".story-slide").querySelector("video");
          if (video) {
            video.muted = true;
          }
          button.style.display = "none";
          const unmuteButton = button
            .closest(".story-slide")
            .querySelector(".unmute-button");
          if (unmuteButton) {
            unmuteButton.style.display = "flex";
          }
        });
      });

      this.unmuteButtons.forEach((button) => {
        button.addEventListener("click", () => {
          const video = button.closest(".story-slide").querySelector("video");
          if (video) {
            video.muted = false;
          }
          button.style.display = "none";
          const muteButton = button
            .closest(".story-slide")
            .querySelector(".mute-button");
          if (muteButton) {
            muteButton.style.display = "flex";
          }
        });
      });

      this.nextStoryBtn.forEach((btn) => {
        btn.addEventListener("click", () => {
          this.openModalStory("next");
        });
      });

      this.prevStoryBtn.forEach((btn) => {
        btn.addEventListener("click", () => {
          this.openModalStory("prev");
        });
      });

      // Close on clicking outside the content
      this.modal.addEventListener("click", (e) => {
        if (e.target === this.modal) this.closeModal();
      });

      // Keyboard navigation
      document.addEventListener("keydown", (e) => {
        if (this.modal.style.display === "block") {
          if (e.key === "ArrowLeft") this.prevSlide();
          if (e.key === "ArrowRight") this.nextSlide();
          if (e.key === "Escape") this.closeModal();
        }
      });
      this.modal.addEventListener("click", (e) => {
        const modalContents = this.querySelectorAll(".stories-modal-content");
        
        let isOutsideContent = true;
        modalContents.forEach(content => {
          if (content.contains(e.target)) {
            isOutsideContent = false;
          }
        });
        
        if (isOutsideContent && !e.target.closest(".story-nav") && 
            !e.target.closest(".play-button") && !e.target.closest(".pause-button") &&
            !e.target.closest(".mute-button") && !e.target.closest(".unmute-button")) {
          this.closeModal();
        }
      });

      // Add touch navigation setup
      this.setupTouchNavigation();
    }
  }

  // Register the custom element
  customElements.define("product-stories", ProductStories);
}